export default __webpack_public_path__ + "static/media/LocationPersonPin.18d64b66.svg";